namespace Roodik.Core
{
	export class AdvertismentFactory
	{
		public static getProvider(provider:AdvertismentProvider, config:IAdvertismentConfig, sm:ISoundManager):IAdvertisment
		{
			switch (provider)
			{
				case AdvertismentProvider.GAMEDISTRIBUTION:
					return new GameDistributionAd(config);
				case AdvertismentProvider.HEYZAP:
					return new HeyzapAdvertisment(config);
				case AdvertismentProvider.CLOUDGAMES:
					return new CloudGames(config,sm);
			}
		}
	}

	export enum AdvertismentProvider
	{
		GAMEDISTRIBUTION = 0,
		HEYZAP = 1,
		CLOUDGAMES = 2
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Advertisment/AdvertismentFactory.ts